import {installVant} from "@/plugins/vant/index.js";
import {installComponentsViews} from "@/plugins/components/index.js";

export const initPlugins = (app)=>{
	installVant(app);
	installComponentsViews(app)
}
